import { EmbeddedRepository } from 'repositories/embedded/embedded';

export function useEmbeddedProps() {
  return EmbeddedRepository.getProps();
}
